import { useEffect, useRef } from "react";

function AutoInc(callback, delay) 
    {
        const savedCallback = useRef();
    
        // Remember the latest callback.
        useEffect(() => {savedCallback.current = callback;}, [callback]);
    
        // Set up the interval.
        useEffect(() => 
        {
            let id = setInterval(() => {savedCallback.current();}, delay);
            return () => clearInterval(id);
        }, [delay]);
    }

export default AutoInc